export const METAPLEX_NAME_MAX_BYTES = 32;

const utf8Encoder = new TextEncoder();

function utf8ByteLength(value: string): number {
  return utf8Encoder.encode(value).length;
}

export function normalizeOptionalUrl(
  value: string | null | undefined,
): string | undefined {
  if (!value) {
    return undefined;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return undefined;
  }

  if (trimmed.startsWith('https://') || trimmed.startsWith('http://')) {
    return trimmed;
  }

  return `https://${trimmed}`;
}

export function normalizeReleaseName(value: string): string {
  const trimmed = value.trim();
  if (utf8ByteLength(trimmed) <= METAPLEX_NAME_MAX_BYTES) {
    return trimmed;
  }

  let metaplexName = '';
  const normalizedName = trimmed.replace(/[–—]/g, '-');

  for (const character of normalizedName) {
    const candidate = metaplexName + character;
    if (utf8ByteLength(candidate) > METAPLEX_NAME_MAX_BYTES) {
      break;
    }
    metaplexName = candidate;
  }

  return metaplexName;
}

export function asRecord(value: unknown): Record<string, unknown> | undefined {
  return typeof value === 'object' && value !== null
    ? (value as Record<string, unknown>)
    : undefined;
}

export function asStringArray(value: unknown): string[] {
  return Array.isArray(value)
    ? value.filter((item): item is string => typeof item === 'string')
    : [];
}

export function toPositiveNumber(value: unknown): number | undefined {
  return typeof value === 'number' && Number.isFinite(value) && value > 0
    ? value
    : undefined;
}

export function extractMediaDimensions(
  metadata: unknown,
): { width: number; height: number } | undefined {
  const record = asRecord(metadata);
  if (!record) {
    return undefined;
  }

  const width = toPositiveNumber(record.width);
  const height = toPositiveNumber(record.height);

  if (!width || !height) {
    return undefined;
  }

  return { width, height };
}
